<img *ngIf="completion && completion.tracking !== 1" [src]="completionImage" [alt]="completionDescription$ | async">

<ion-button fill="clear" *ngIf="completion && completion.tracking === 1" (click)="completionClicked($event)"
    [title]="completionDescription$ | async">
    <img [src]="completionImage" role="presentation" alt="">
</ion-button>
